import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

import CarrierDialogStandardActions from "./CarrierDialogStandardActions";

export default function CarrierCompanyDialogs({ vm }) {
  const {
    openEditCompanyDialog,
    handleCloseCompanyDialog,
    setOpenEditCompanyDialog,
    handleUpdateCompany,
    handleAddCompany,
    editCompanyName,
    companyName,
    editCompanyNAIC,
    companyNAIC,
    setEditCompanyNAIC,
    setCompanyNAIC,
    setEditCompanyName,
    setCompanyName,
    openCompanyDialog,
    isSubmitting,
  } = vm;

  return (
    <>
      <Dialog open={openCompanyDialog} onClose={handleCloseCompanyDialog}>
        <DialogTitle>Add New Company</DialogTitle>
        <DialogContent sx={{ width: "400px" }}>
          <TextField
            autoFocus
            margin="dense"
            label="Company Name"
            type="text"
            fullWidth
            variant="outlined"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
          />
          <TextField
            margin="dense"
            label="NAIC"
            type="text"
            fullWidth
            variant="outlined"
            value={companyNAIC}
            onChange={(e) => setCompanyNAIC(e.target.value)}
          />
        </DialogContent>
        <CarrierDialogStandardActions
          onCancel={handleCloseCompanyDialog}
          onSubmit={handleAddCompany}
          submitting={isSubmitting}
          submitLabel="Add Company"
        />
      </Dialog>

      <Dialog open={openEditCompanyDialog} onClose={() => setOpenEditCompanyDialog(false)}>
        <DialogTitle>Edit Company</DialogTitle>
        <DialogContent sx={{ width: "400px" }}>
          <TextField
            autoFocus
            margin="dense"
            label="Company Name"
            type="text"
            fullWidth
            variant="outlined"
            value={editCompanyName}
            onChange={(e) => setEditCompanyName(e.target.value)}
          />
          <TextField
            margin="dense"
            label="NAIC"
            type="text"
            fullWidth
            variant="outlined"
            value={editCompanyNAIC}
            onChange={(e) => setEditCompanyNAIC(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditCompanyDialog(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleUpdateCompany} color="primary" variant="contained" disabled={isSubmitting}>
            {isSubmitting ? <CircularProgress size={24} /> : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

CarrierCompanyDialogs.propTypes = {
  vm: PropTypes.object.isRequired,
};
